module.exports = __webpack_public_path__ + "static/img/1-1.b98f553.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/1-1.png
// module id = zAho
// module chunks = 0